<template>
	<div class="container-fluid bg-white">
		<safety-toolbar heading="Manage Certificates" icon="fa-id-card"></safety-toolbar>

		<p>Create a list of certficates you would like to track. Employees can upload certificates they hold, and associate them to a certificate on this list.</p>

		<table-list
			record-name="Certificate"
			:fields="fields"
			:records="mutatedCerts"
			:hide-record-count="true"
			:has-edit="true"
			v-on:edit="editCert"
			:has-delete="true"
			delete-endpoint="CompanyCertificate/delete"
			v-on:modelChange="fetchData()">

			<button class="btn btn-success" v-on:click="newCert">
				<i class="fa fa-plus"></i>
				Add Certificate
			</button>
		</table-list>

		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			v-on:closeModal="editModal.visible = false"
			v-on:confirm="saveCert"
			confirm-button-text="Save">

			<field label="Certificate Name"
				col-class="col-md-5"
				v-model="editModal.payload.cert_name">
			</field>

			<field label="Acronym/Short Name"
				col-class="col-md-5"
				v-model="editModal.payload.short_name">
			</field>

			<field label="Required for Work"
				col-class="col-md-5"
				v-model="editModal.payload.required_for_work"
				:params="{type:'select-multi',options:classificationOptions}">
			</field>

		</modal-dialog>
	</div>
</template>
<script type="text/javascript">
import SafetyToolbar from "./SafetyToolbar"
import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import Field from "@/components/Field"

export default {
	name: "ManageCertificates",
	components: {
		SafetyToolbar,
		ModalDialog,
		TableList,
		Field
	},
	data() {
		return {
			certs: [],
			fields: [
				{label: "Certificate",key:"cert_name"},
				{label: "Acronym/Short Name",key:"short_name"},
				{label: "Required for Work",key:"requiredForWork"}
			],
			editModal: {
				visible: false,
				payload: {},
				title: "Add Certificate"
			},
			classifications: []
		}
	},
	computed: {
		classificationOptions() {
			return this.optionify(this.classifications,"title")
		},
		mutatedCerts() {
			let vm = this

			let textListClassificationMaxLength = 100
			if (window.innerWidth < 800)
				textListClassificationMaxLength = 40

			return this.certs.map(cert => {
				let classificationsList = []

				try {
					classificationsList = JSON.parse(cert.required_for_work_classification_ids_json)
				}
				catch (e) {}

				let textList = vm.classifications.filter(cls => classificationsList.indexOf(cls.id) >= 0).map(cls => cls.title).join(", ")

				if (textList.length > textListClassificationMaxLength)
					textList = textList.substr(0,textListClassificationMaxLength)+"..."

				cert.requiredForWork = textList

				return cert
			})
		}
	},
	methods: {
		newCert() {
			this.editModal.visible = true
			this.editModal.payload = {
				cert_name: "",
				required_for_work: []
			}
		},
		editCert(cert) {
			this.editModal.visible = true
			this.editModal.payload = cert

			try {
				this.editModal.payload.required_for_work = JSON.parse(cert.required_for_work_classification_ids_json)
			}
			catch (E) {
				this.editModal.payload.required_for_work = []
			}
		},
		saveCert() {
			let vm = this

			let payload = JSON.parse(JSON.stringify(this.editModal.payload))

			payload.required_for_work_classification_ids_json = JSON.stringify(payload.required_for_work)
			delete payload.required_for_work

			this.postData("CompanyCertificate/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Certificate saved")
					vm.editModal.visible = false
					vm.fetchData()
				}
			})
		},
		fetchData() {
			let vm = this

			vm.spinner(true)

			let promises = [
				this.getJSON("CompanyCertificate/get"),
				this.getJSON("EmployeeClassification/get")
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success)
					vm.certs = responses[0].data

				if (responses[1].success)
					vm.classifications = responses[1].data
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>